import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { ToastService } from 'services/toast-service';
import { FloaterTypeService } from 'services/floater-type-service';
import { AsyncErrorHandler } from 'lib/ui';
import { ValidationController, ValidationControllerFactory, Validator } from 'aurelia-validation';

@autoinject
export class FloaterTypeNew {
  private floaterType: Models.FloaterType = new Models.FloaterType();

  protected validationController: ValidationController;

  private constructor(
    private eventAggregator: EventAggregator,
    private router: Router,
    private toastService: ToastService,
    private floaterTypeService: FloaterTypeService,
    protected validator: Validator,
    validationController: ValidationControllerFactory
  ) {
    this.validationController = validationController.createForCurrentScope();
  }

  @AsyncErrorHandler
  protected async createFloaterType() {
    const validationResult = await this.validationController.validate();
    if (!validationResult.valid) {
      return;
    }

    const { Id } = await this.floaterTypeService.post(this.floaterType);

    this.eventAggregator.publish('floaterTypeListReset', 1);
    this.toastService.showSuccess('floaterType.created');
    this.router.navigateToRoute('floater-type-detail', { Id });
  }
}
